import { render, staticRenderFns } from "./QuoteCarousel.vue?vue&type=template&id=74f87ee4&"
import script from "./QuoteCarousel.vue?vue&type=script&lang=js&"
export * from "./QuoteCarousel.vue?vue&type=script&lang=js&"
import style0 from "./QuoteCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports